import { render, staticRenderFns } from "./billsManagement.vue?vue&type=template&id=21d864a2&scoped=true&"
import script from "./billsManagement.vue?vue&type=script&lang=js&"
export * from "./billsManagement.vue?vue&type=script&lang=js&"
import style0 from "./billsManagement.vue?vue&type=style&index=0&id=21d864a2&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./billsManagement.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d864a2",
  null
  
)

export default component.exports